import * as React from 'react';
import { useEditorContext } from '../editor_context';
import { InsertTableButton } from './buttons';
import { ToggleTableHeaderButton } from './buttons/table/ToggleTableHeaderButton';
import { MenuSeparator } from './MenuSeparator';
import { AlignmentDropdown } from './AlignmentDropdown';
import { TableCellDropdown } from './TableCellDropdown';
import { TableTextColorDropdown } from './TableTextColorDropdown';
import { TableBackgroundColorDropdown } from './TableBackgroundColorDropdown';

interface TableMenuProps {
   preSeparator?: boolean;
   postSeparator?: boolean;
}

export const TableMenu = (props: TableMenuProps) => {
   const { editor } = useEditorContext();

   if (!editor.schema.nodes.table) {
      return null;
   }

   return (
      <>
         {props.preSeparator ? <MenuSeparator /> : null}
         {editor.isActive('table') ? (
            <>
               <TableCellDropdown />
               <ToggleTableHeaderButton />
               <AlignmentDropdown />
               <TableTextColorDropdown />
               <TableBackgroundColorDropdown />
            </>
         ) : (
            <InsertTableButton />
         )}
         {props.postSeparator ? <MenuSeparator /> : null}
      </>
   );
};
